import Vue from 'vue'

// axios
import axios from 'axios'

export const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  baseURL: process.env.VUE_APP_API_URL ?? '/api',
  // timeout: 1000,
  // headers: {'X-Custom-Header': 'foobar'}
})

export const tiktokIns = axios.create({
  // You can add your headers here
  // ================================
  baseURL: process.env.VUE_APP_TIKTOK_API_URL ?? '/tiktok/api',
  // timeout: 1000,
  // headers: {'X-Custom-Header': 'foobar'}
})

Vue.prototype.$http = axiosIns

export default axiosIns
